<template>
    <outboxCon :bg="bg">
        <div class="aptitude-box">
            <app-title main="了解学生才能更好的因材施教" sub="洞察学生学习情况，真正实施因材施教"></app-title>
            <div class="aptitude-info">
                <div class="aptitude-item">
                    <img class="aptitude-item part-img1" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-2-1.png">
                </div>
                <div class="aptitude-item no-right">
                    <div class="step-box">
                        <p class="step">step<span class="strong">1</span></p>
                        <p class="title">洞察学生学习情况</p>
                    </div>
                </div>
                <div class="aptitude-item step-box">
                    <div class="step-box">
                        <p class="step">step<span class="strong">2</span></p>
                        <p class="title">实施教学决策</p>
                    </div>
                </div>
                <div class="aptitude-item no-right">
                    <img class="aptitude-item part-img2" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-2-2.png">
                </div>
                <div class="step-middle">
                    <div class="step-num">1</div>
                    <div class="line"></div>
                    <div class="step-num">2</div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
export default {
  props: {
    bg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
    .aptitude-box{
        padding: 50px 220px 70px;
        width: $main-width;
        margin: 0 auto;
        .aptitude-info{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            position: relative;
            .aptitude-item{
                width: 375px;
                margin-right: 90px;
                margin-top: 40px;
                .part-img1{
                    width: 348px;
                    height: 251px;
                }
                .part-img2{
                    width: 380px;
                    height: 260px;
                }
                .step-box{
                    text-align: left;
                    .step{
                        font-size:50px;
                        font-family:Impact;
                        color:rgba(203,228,255,1);
                        line-height:69px;
                        background:linear-gradient(180deg, rgba(211,217,255,1) 0%, rgba(255,255,255,1) 100%);
                        -webkit-background-clip:text;
                        -webkit-text-fill-color:transparent;
                        .strong{
                            font-size: 80px;
                        }
                    }
                    .title{
                        font-size:36px;
                        font-family:PingFangSC-Semibold,PingFang SC;
                        font-weight:600;
                        line-height:50px;
                        margin-top: -10px;
                    }
                    .intro{
                        margin-top: 19px;
                        font-size:16px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        line-height:22px;
                    }
                }
                &.no-right{
                    margin-right: 0px;
                }
            }
            .step-middle{
                position: absolute;
                top: 200px;
                left: 370px;
                .step-num{
                    width:57px;
                    height:57px;
                    border-radius: 50%;
                    overflow: hidden;
                    background:#D3D9FF;
                    font-size:40px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:#ffffff;
                    line-height:56px;
                }
                .line{
                    width: 0px;
                    height: 238px;
                    border: none;
                    outline: none;
                    border-left: 1px dashed #979797;
                    margin-left: 27px;
                }
            }
        }
    }
</style>
